import React, { SVGProps } from 'react';

const Menu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="var(--secondaryBackground)"
    {...props}
    data-palette="Menu">
    <path
      d="M10.5 7h12.833M10.5 14h12.833M10.5 21h12.833M5.833 7v.012M5.833 14v.012M5.833 21v.012"
      stroke="var(--dropdownIconColor)"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Menu;
